import { CheckoutContactData } from "src/checkout/state/checkoutContactStore"
import { GeoData } from "src/integrations/lib/geoData"
import { cleanObject } from "src/utilities/object"
import { PartialDeep } from "type-fest"

export type PlainAddressData = {
  company: string
  firstName: string
  lastName: string
  countryCode: string
  regionCode: string
  postalCode: string
  city: string
  street: string
}

export type PlainUserData = {
  userId: string
  email: string
  phoneNormalized: string | undefined
  address: PlainAddressData
}

export function buildPlainUserData(
  userId: string,
  geoData: GeoData | null,
  contactData: PartialDeep<CheckoutContactData>,
) {
  const billing = contactData.billingAddress
  const shipping = contactData.shippingAddress

  const address = cleanObject<Partial<PlainAddressData>>({
    company: billing?.companyName?.value || shipping?.companyName?.value,
    firstName: billing?.firstName?.value || shipping?.firstName?.value,
    lastName: billing?.lastName?.value || shipping?.lastName?.value,
    countryCode: billing?.countryCode?.value || shipping?.countryCode?.value || geoData?.country_code,
    regionCode: geoData?.region_code, //  we do not collect this information during checkout
    postalCode: billing?.postalCode?.value || shipping?.postalCode?.value || geoData?.postal,
    street: billing?.street?.value || shipping?.street?.value,
    city: billing?.city?.value || shipping?.city?.value || geoData?.city,
  })

  const userData = cleanObject<PartialDeep<PlainUserData>>({
    userId: userId,
    email: billing?.email?.value,
    phoneNormalized: billing?.phoneNormalized,
    address: address,
  })

  return userData
}
